import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreSonarObjectsInitiativesGetAsyncSlice } from './get';

export const coreSonarObjectsInitiativesReducers = combineReducers({
	get: coreSonarObjectsInitiativesGetAsyncSlice.asyncReducers
});

export const coreSonarObjectsInitiativesWatchers = combineAllWatchers([
	coreSonarObjectsInitiativesGetAsyncSlice.asyncWatchers
]);
